const slider_config_type = {
  1: {
    slidesPerView:"auto",
    spaceBetween: 12,
    

    breakpoints: {
      1: {
        slidesPerView:"auto",
        centeredSlides: true,
        spaceBetween: 15,
        initialSlide: 1,
      },
      393: {
        slidesPerView: 2.175,
      },
      500: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 21,
      },
      1280: {
        slidesPerView: 6,
      },
    },
  },
  2: {
    slidesPerView:1.5,
    spaceBetween: 12,
    breakpoints: {
      1: {
        slidesPerView:1.2,
        spaceBetween: 20,
      },

      768: {
        slidesPerView: 1.45,
        spaceBetween: 12,
      },
    }
  },
   3: {
    slidesPerView: 1,
    spaceBetween: 0,
  }
};

if (!customElements.get('custom-slider')) {
  class CustomSlider extends HTMLElement {
    connectedCallback() {
      if (this.swiper && !this.swiper.destroyed) return;

      this.index = this.dataset.index || 1;

      const noNavigation = this.hasAttribute('data-no-navigation');

      const nextEl = !noNavigation
        ? this.querySelector('.swiper-button-next') ||
          this.closest('.shopify-section')?.querySelector('.swiper-button-next')
        : null;

      const prevEl = !noNavigation
        ? this.querySelector('.swiper-button-prev') ||
          this.closest('.shopify-section')?.querySelector('.swiper-button-prev')
        : null;

      const navigation = nextEl && prevEl
        ? {
            navigation: {
              nextEl,
              prevEl,
            },
          }
        : {};

      const paginationSelector = this.dataset.paginationEl;
      const paginationEl = paginationSelector
        ? this.closest('.os-sh__img-col')?.querySelector(paginationSelector) || this.querySelector('.swiper-pagination')
        : this.querySelector('.swiper-pagination');
      const paginationConfig = this.hasAttribute('data-pagination') && paginationEl
        ? {
            pagination: {
              el: paginationEl,
              clickable: true,
            },
          }
        : {};

      this.config = {
        ...slider_config_type[this.index],
        ...navigation,
        ...paginationConfig,
        observer: true,
        observeParents: true,
      };

      this.swiper = new Swiper(this, this.config);
    }
  }

  customElements.define('custom-slider', CustomSlider);
}